export const doThing = <T>(callback: (args: T) => any, args?: T) => {
    callback(args!);
}

export const get10th = (arr?: any[]) => {
    return arr![10];
}